import React, { ReactElement } from "react";
import { VisState } from "../../helpers/vis";
import { Event } from "./data";
import OpenColor from "open-color";
import "./EventsTable.css";
import t from "../../helpers/i18n";
import { rawWriteRegister } from "../../helpers/params";
import { Device } from "../../helpers/org-struct";

export default function EventsTable({
  vis,
  events,
  device,
  showSpinner,
}: {
  vis: VisState;
  events: Event[];
  device: Device;
  showSpinner: (show: boolean) => void;
}): ReactElement {
  const eventsSorted = events.sort((a, b) => {
    if (a.day < b.day) return -1;
    if (a.day > b.day) return 1;
    if (a.startMin < b.startMin) return -1;
    if (a.startMin > b.startMin) return 1;
    return 0;
  });

  return (
    <table className="events-table">
      <tbody>
        {eventsSorted.map((scheduleEvent, i) => (
          <tr key={i}>
            <td style={{ width: "80px" }}>
              {
                [
                  t("MN", "ПН"),
                  t("TU", "ВТ"),
                  t("WD", "СР"),
                  t("TH", "ЧТ"),
                  t("FR", "ПТ"),
                  t("SA", "СБ"),
                  t("SU", "ВС"),
                ][scheduleEvent.day]
              }
            </td>
            <td style={{ width: "110px" }}>
              <span style={{ color: OpenColor.green[7], marginRight: "5px" }}>
                <i className="fas fa-lightbulb"></i>
              </span>
              {minutesToHHmm(scheduleEvent.startMin)}
            </td>
            <td style={{ width: "150px" }}>
              <span style={{ color: OpenColor.gray[6], marginRight: "5px" }}>
                <i className="fas fa-lightbulb"></i>
              </span>
              {minutesToHHmm(scheduleEvent.endMin)}
            </td>
            <td style={{ textAlign: "right" }}>
              <button
                className="delete-button"
                /* eslint-disable-next-line @typescript-eslint/no-misused-promises */
                onClick={async () => {
                  const confirm = window.confirm(t("Delete event?", "Удалить событие?"));
                  if (!confirm) return;
                  showSpinner(true);
                  await vis.params.rawWriteRegister(scheduleEvent.storeKeys[0], [0, 0]);
                  await vis.params.readNowFromDevice(scheduleEvent.storeKeys[1]);
                  await rawWriteRegister(device.netId, device.modbusUnitId, 120, "holding", [4]);
                  showSpinner(false);
                }}
              >
                <i className="fas fa-trash"></i>
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function minutesToHHmm(min: number): string {
  const hours = Math.floor(min / 60)
    .toFixed(0)
    .padStart(2, "0");
  const minutes = (min % 60).toFixed(0).padStart(2, "0");
  if (hours === "24") return `00:00 ${t("(next day)", "(след. дня)")}`;
  return `${hours}:${minutes}`;
}
